import { useAuth } from '../context/AuthContext';
import type { UserRole } from '../types/index.js';

type Capability =
  | 'mutate'            // create / edit / delete city-scoped data
  | 'edit_city_config'  // zipcodes / scrape urls / scrape config (city_admin)
  | 'manage_users'      // create/edit/delete users (within own city)
  | 'manage_cities'     // system_admin: City settings
  | 'manage_status'     // system_admin: status configuration
  | 'manage_page_layout'// system_admin: page/column/section visibility
  | 'restore_hidden'    // restore items hidden by any user (stadt-admin trash view)
  | 'restore_own';      // restore items the user themselves hid

const CAPS: Record<Capability, UserRole[]> = {
  mutate:            ['system_admin', 'city_admin', 'member'],
  edit_city_config:  ['system_admin', 'city_admin'],
  manage_users:      ['system_admin', 'city_admin'],
  manage_cities:     ['system_admin'],
  manage_status:     ['system_admin'],
  manage_page_layout:['system_admin'],
  restore_hidden:    ['system_admin', 'city_admin'],
  restore_own:       ['system_admin', 'city_admin', 'member'],
};

export function useCan(capability: Capability): boolean {
  const { user } = useAuth();
  if (!user) return false;
  return CAPS[capability].includes(user.role);
}

export function useRole(): UserRole | null {
  const { user } = useAuth();
  return user?.role ?? null;
}
